// extracted by mini-css-extract-plugin
export default {"slider":"Sliders_slider__3C-Ix","slider_title":"Sliders_slider_title__VqCsV"};